import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HvlConfigurationService } from '@hvlng/framework-bff/core';
import { TranslateService } from '@ngx-translate/core';
import { HvlLanguageService } from '@hvlng/framework-core/language';

@Component({
    selector: 'hr-rec-root',
    templateUrl: './hr-rec-root.component.html',
})
export class HrRecRootComponent implements OnInit {
    constructor(
        private router: Router,
        private titleService: Title,
        private route: ActivatedRoute,
        private configurationService: HvlConfigurationService,
        private readonly translate: TranslateService,
        private hvlLangService: HvlLanguageService,
    ) {
        let lang = this.hvlLangService.getLanguage();
        if (!lang) {
            lang = this.configurationService.config?.theme?.language?.system?.code || 'tr';
        }
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
    }

    ngOnInit(): void {
        let config = this.configurationService.config['pageTitle'];
        if (config && config != null && config != '') {
            this.titleService.setTitle(config);
        } else {
            this.titleService.setTitle('Havelsan');
        }
    }
}
